import { useMemo } from 'react';
import { makeHeadingElementKey } from '../../../utils/heading-structure-utils';
export const useAiNotificationCounts = (headings, aiResult) => {
  const headingByKey = useMemo(() => new Map(headings.map(heading => [makeHeadingElementKey(heading.componentId, heading.attributeId, heading.elementId), heading])), [headings]);
  const aiSuggestedElementIds = useMemo(() => {
    var _aiResult$suggestions;
    return new Set((aiResult == null || (_aiResult$suggestions = aiResult.suggestions) == null ? void 0 : _aiResult$suggestions.map(suggestion => makeHeadingElementKey(suggestion.id, suggestion.attributeId, suggestion.uiElementId))) ?? []);
  }, [aiResult]);
  const aiManualCount = useMemo(() => {
    var _aiResult$suggestions2;
    return (aiResult == null || (_aiResult$suggestions2 = aiResult.suggestions) == null ? void 0 : _aiResult$suggestions2.filter(suggestion => {
      const heading = headingByKey.get(makeHeadingElementKey(suggestion.id, suggestion.attributeId, suggestion.uiElementId));
      if (!(heading != null && heading.isGeneric)) {
        return false;
      }
      return (suggestion.proposedTag ?? '').toLowerCase() !== (heading.headingDefinition ?? '').toLowerCase();
    }).length) ?? 0;
  }, [aiResult, headingByKey]);
  const fixedCount = useMemo(() => {
    var _aiResult$suggestions3;
    return (aiResult == null || (_aiResult$suggestions3 = aiResult.suggestions) == null ? void 0 : _aiResult$suggestions3.filter(suggestion => {
      const heading = headingByKey.get(makeHeadingElementKey(suggestion.id, suggestion.attributeId, suggestion.uiElementId));
      return heading !== undefined && !heading.isGeneric;
    }).length) ?? 0;
  }, [aiResult, headingByKey]);
  const unresolvedSuggestionKeys = useMemo(() => {
    var _aiResult$suggestions4;
    return new Set((aiResult == null || (_aiResult$suggestions4 = aiResult.suggestions) == null ? void 0 : _aiResult$suggestions4.filter(suggestion => {
      const heading = headingByKey.get(makeHeadingElementKey(suggestion.id, suggestion.attributeId, suggestion.uiElementId));
      if (!(heading != null && heading.isGeneric)) {
        return false;
      }
      return (suggestion.proposedTag ?? '').toLowerCase() !== (heading.headingDefinition ?? '').toLowerCase();
    }).map(suggestion => makeHeadingElementKey(suggestion.id, suggestion.attributeId, suggestion.uiElementId))) ?? []);
  }, [aiResult, headingByKey]);
  const firstFailedGenericSuggestionElementId = useMemo(() => {
    var _headings$find;
    return (_headings$find = headings.find(heading => heading.isGeneric && unresolvedSuggestionKeys.has(makeHeadingElementKey(heading.componentId, heading.attributeId, heading.elementId)))) == null ? void 0 : _headings$find.elementId;
  }, [headings, unresolvedSuggestionKeys]);
  return {
    aiManualCount,
    aiSuggestedElementIds,
    firstFailedGenericSuggestionElementId,
    fixedCount
  };
};
//# sourceMappingURL=use-ai-notification-counts.js.map